import { Box, Center, Flex, Icon, IconButton } from "@chakra-ui/react"
import useMobile from "../../hooks/useMobile"
import { scrollbarStyle } from "../../theme/scrollbarStyles"
import { ArrowLeft } from "../icons/icons"
import { useNavigate } from "react-router-dom"
import { SafeArea } from "capacitor-plugin-safe-area"
import { ReactNode, useEffect, useState } from "react"





const AuthWrapper = ({children}:{children:ReactNode}) => {
    const isTablet = useMobile(1320)
    const isMobile = useMobile(630)

    const navigate = useNavigate()
    const [statusBarHeight, setStatusBarHeight] = useState<number>(0);

    useEffect(() => {
      SafeArea.getStatusBarHeight().then(({ statusBarHeight }) => {
        setStatusBarHeight(statusBarHeight);
      });
    }, []);
  
    

    if(isMobile) return <>
    <Box display='relative' w='100%' h='100vh'>
        <Box h='33%' w='100%'
            bgImage='/bg.png'
            bgSize='cover'
            position='absolute'
            bgPos='center'
            userSelect="none" // Prevent selection of the logo
        />
        <IconButton
            minW='34px' h='34px'
            variant='light'
            top="30px"
            left="20px"
            zIndex = "100"
            mt={statusBarHeight + "px"}
            aria-label="go back"
            onClick={() => window.history.length > 1 ? navigate(-1) : navigate('/user/play')}
            icon={<Icon width="20px" height="19px" viewBox="0 0 23 20">
                <ArrowLeft color='#171C22' />
            </Icon>}
        />
        </Box>
        <Box 
            w='100%' h='70%' bg='white' position='absolute' bottom='0'
            p='30px 16px'
        >
            {children}
            <Box h='64px' />
    </Box>
    </>

    return <Flex w='100%' h='100vh'>
        <Box h='100%' w={isTablet ? '35%' : '55%'}
            bgImage='/bg.png'
            bgSize='cover'
            bgPos='center'
            userSelect="none" // Prevent selection of the logo

        />
        <Box h='100%' w={isTablet ? '65%' : '45%'} bg='white' p='100px 6%'
            overflowY='auto' sx={scrollbarStyle} position='relative'
        >
            <IconButton
                minW='34px' h='34px'
                variant='light'
                position='absolute'
                top="30px"
                left="20px"
                aria-label="go back"
                onClick={() => window.history.length > 1 ? navigate(-1) : navigate('/user/play')}
                icon={<Icon width="20px" height="19px" viewBox="0 0 23 20">
                    <ArrowLeft color='#171C22' />
                </Icon>}
            />
            <Center w='100%'>
                {children}
            </Center>

        </Box>
            
    </Flex>
}


export default AuthWrapper